var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"color-gradient-picker"},[_c('Gradient',{attrs:{"points":_vm.value.points,"type":_vm.type,"degree":_vm.value.degree,"onChange":_vm.onGradientSelected,"onStartChange":_vm.onGradientSelected,"onEndChange":_vm.onGradientSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }